// components/StatusBar.js
import React from "react";
import { STATUS_BAR_COLORS, WEATHER_EMOJI } from "../theme";

const StatusBar = ({ data, showBottomPane, isMuted, elapsedTime }) => {
  const batteryPercentage = Math.round(data.battery);
  const distancePercentage =
    (data.distance_traveled / data.total_distance) * 100;

  // バッテリーの色を決定
  const getBatteryColor = (percentage) => {
    if (percentage < 25) return STATUS_BAR_COLORS.battery.low;
    if (percentage < 50) return STATUS_BAR_COLORS.battery.medium;
    return STATUS_BAR_COLORS.battery.high;
  };

  const batteryColor = getBatteryColor(batteryPercentage);

  // 時間のフォーマット関数
  const formatTime = (seconds) => {
    const hours = Math.floor(seconds / 3600);
    const minutes = Math.floor((seconds % 3600) / 60);
    const secs = Math.floor(seconds % 60);

    if (hours > 0) {
      return `${hours}:${minutes.toString().padStart(2, "0")}:${secs
        .toString()
        .padStart(2, "0")}`;
    } else {
      return `${minutes}:${secs.toString().padStart(2, "0")}`;
    }
  };

  return (
    <div
      style={{
        backgroundColor: STATUS_BAR_COLORS.background,
      }}
      className="px-4 py-2"
    >
      <div className="grid grid-cols-2 sm:grid-cols-3 md:grid-cols-5 gap-4">
        <div className="flex flex-col space-y-1">
          <div className="flex justify-between items-center">
            <span
              className="text-xs"
              style={{ color: STATUS_BAR_COLORS.label }}
            >
              経過時間
            </span>
          </div>
          <span
            className="text-sm font-semibold font-mono"
            style={{ color: STATUS_BAR_COLORS.weather }}
          >
            {formatTime(elapsedTime)}
          </span>
        </div>

        {/* バッテリー情報 */}
        <div className="flex flex-col space-y-1">
          <div className="flex justify-between items-center">
            <span
              className="text-xs"
              style={{ color: STATUS_BAR_COLORS.label }}
            >
              バッテリー
            </span>
            <span
              className="text-sm font-semibold"
              style={{ color: batteryColor }}
            >
              {batteryPercentage}%
            </span>
          </div>
          <div
            className="w-full rounded-full h-2"
            style={{ backgroundColor: STATUS_BAR_COLORS.progressBg }}
          >
            <div
              className="h-2 rounded-full"
              style={{
                width: `${batteryPercentage}%`,
                backgroundColor: batteryColor,
              }}
            />
          </div>
        </div>

        {/* 走行距離情報 */}
        <div className="flex flex-col space-y-1">
          <div className="flex justify-between items-center">
            <span
              className="text-xs"
              style={{ color: STATUS_BAR_COLORS.label }}
            >
              走行距離
            </span>
            <span
              className="text-sm font-semibold"
              style={{ color: STATUS_BAR_COLORS.distance.traveled }}
            >
              {data.distance_traveled.toFixed(1)} km
            </span>
          </div>
          <div
            className="w-full rounded-full h-2"
            style={{ backgroundColor: STATUS_BAR_COLORS.progressBg }}
          >
            <div
              className="h-2 rounded-full"
              style={{
                width: `${distancePercentage}%`,
                backgroundColor: STATUS_BAR_COLORS.distance.traveled,
              }}
            />
          </div>
        </div>

        {/* 残り距離 */}
        <div className="flex flex-col space-y-1">
          <div className="flex justify-between items-center">
            <span
              className="text-xs"
              style={{ color: STATUS_BAR_COLORS.label }}
            >
              残り距離
            </span>
            <span
              className="text-sm font-semibold"
              style={{ color: STATUS_BAR_COLORS.distance.remaining }}
            >
              {data.distance_left.toFixed(1)} km
            </span>
          </div>
          <div
            className="w-full rounded-full h-2"
            style={{ backgroundColor: STATUS_BAR_COLORS.progressBg }}
          >
            <div
              className="h-2 rounded-full"
              style={{
                width: `${(data.distance_left / data.total_distance) * 100}%`,
                backgroundColor: STATUS_BAR_COLORS.distance.remaining,
              }}
            />
          </div>
        </div>

        {/* 天気とテンポ */}
        <div className="flex flex-col space-y-1">
          <div className="flex justify-between items-center">
            <span
              className="text-xs"
              style={{ color: STATUS_BAR_COLORS.label }}
            >
              {showBottomPane ? "天気/テンポ" : "天気"}
            </span>
            <span
              className="text-sm font-semibold"
              style={{ color: STATUS_BAR_COLORS.weather }}
            >
              {WEATHER_EMOJI[data.weather]}
              {showBottomPane && ` ${data.tempo} BPM`}
            </span>
          </div>
          {showBottomPane && (
            <div className="flex items-center space-x-2">
              <span
                className="text-xs px-2 py-1 rounded"
                style={{
                  backgroundColor: isMuted
                    ? STATUS_BAR_COLORS.warning.bg
                    : data.is_paused
                    ? STATUS_BAR_COLORS.playStatus.paused.bg
                    : STATUS_BAR_COLORS.playStatus.playing.bg,
                  color: isMuted
                    ? STATUS_BAR_COLORS.warning.text
                    : data.is_paused
                    ? STATUS_BAR_COLORS.playStatus.paused.text
                    : STATUS_BAR_COLORS.playStatus.playing.text,
                }}
              >
                {isMuted ? "ミュート" : data.is_paused ? "一時停止" : "再生中"}
              </span>
              {data.is_dissonant && (
                <span
                  className="text-xs px-2 py-1 rounded"
                  style={{
                    backgroundColor: STATUS_BAR_COLORS.warning.bg,
                    color: STATUS_BAR_COLORS.warning.text,
                  }}
                >
                  警告
                </span>
              )}
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

export default StatusBar;
